export default "__VITE_ASSET__BDEeNaML__"